import React, { useState, useEffect, useContext } from "react";
import classNames from "classnames";
import * as Icons from "Components/Icons";
import { Module, ModuleCaption } from "Components/Module";
import { ContentItemViewModel, PortalClient } from "Services/API/API";
import { useApiClient } from "Services/API/useApiClient";
import AccountContext from "../../AccountContext";

interface FAQItemProps {
   question: string;
   answer: string;
   toggled: boolean;
   onToggle: () => void;
}
const FAQItem: React.FC<FAQItemProps> = ({ question, answer, toggled, onToggle }) => {  
   return (
      <div className={classNames("faq-item", { "faq-item--toggled": toggled })} onClick={onToggle}>
         <div className="faq-item-content">
            <div className="faq-item-question" >
               {question}
            </div>
            <div className="faq-item-answer-wrapper" onClick={(e) => e.stopPropagation()}>
               <div className="faq-item-answer" dangerouslySetInnerHTML={{ __html: answer }}>               
               </div>
            </div>            
         </div>
         <div className="faq-item-toggle">
            <Icons.Dropdown />
         </div>         
      </div>
   );
}

interface FAQModuleProps {   
   
}
export const FAQModule: React.FC<FAQModuleProps> = ({ children }) => {  
   const account = useContext(AccountContext);
   const portalClient = useApiClient(PortalClient);
   const [isLoading, setLoading] = useState(true);
   const [questionsAndAnswers, setQuestionsAndAnswers] = useState<ContentItemViewModel[]>([]);   
   const [toggledQuestion, setToggledQuestion] = useState<number | null>(null);

   const toggleQuestion = (index: number) => {
      setToggledQuestion(toggledQuestion == null || toggledQuestion != index ? index : null);
   }

   const loadFAQ = async () => {
      setLoading(true);
      try {
         setQuestionsAndAnswers(await portalClient.questionsAndAnswers(account.id));
      } catch {}
      setLoading(false);
   }

   useEffect(() => {
      loadFAQ();
   }, []);

   return (<Module size="lg" className="module-faq" loading={isLoading}>
      <ModuleCaption className="mb-px24">FAQ</ModuleCaption>
      <div className="module-faq-content">
         {questionsAndAnswers.map((qa, index) => <FAQItem key={`faqi-${index}`} question={qa.subject!} answer={qa.content!} toggled={toggledQuestion == index} onToggle={() => toggleQuestion(index)} />)}
      </div>
   </Module>);
}